module.exports = __webpack_public_path__ + "static/media/language-en.109421aa.svg";